import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Modal, Form, Input, Radio } from 'antd';
import _ from 'lodash';
import { connect } from 'react-redux';

import AnomalyFeedbackTable from '../AnomalyFeedbackTable';
import localStorage from '../../../../../../utils/localStorage';
import { PREDICTIONS } from '../../../../../../commons/api';
import StyledTable from '../../../../../../commons/styles/table';

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 10 }
};

const SummaryTable = (props) => {
  const [dataSource, setDataSource] = useState(props.summaryTable || {});
  const [date, setDate] = useState('');
  // const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const [openModal, setOpenModal] = useState(false);
  const [feedbackForm, setFeedbackForm] = useState(props.feedbackForm || {});
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    if (props.summaryTable) {
      if (props.predictionsType === 'arrayOfArray') {
        _generateColumnsFromDatasource(props.summaryTable[3], props.translationCache);
        setDate(props.summaryTable[0]);
        setFeedbackForm(props.feedbackForm);
      } else {
        _generateColumnsFromDatasource(props.summaryTable.tagsList, props.translationCache);
        setDate(props.summaryTable.time);
        setFeedbackForm(props.feedbackForm);
      }
    }
  }, [props.summaryTable, props.predictionsType, props.feedbackForm]);

  const _generateColumnsFromDatasource = (dataSource, translationCache) => {
    let columns = [];
    if (dataSource && Array.isArray(dataSource) && dataSource.length > 0) {
      columns = Object.keys(dataSource[0]).map((columnName) => {
        return {
          title: translationCache && translationCache[_.startCase(columnName)]
            ? translationCache[_.startCase(columnName)]
            : _.startCase(columnName),
          dataIndex: columnName,
          key: columnName,
          render: (text, row) => ({
            props: {
              style: {
                backgroundColor: '#000',
                color: row.severity ? getColor(row.severity) : '#f9f9a3'
              }
            },
            children: (
              <span onClick={() => setOpenModal(true)}>
                {text}
              </span>
            )
          })
        };
      });
    }

    setColumns(columns);
    setDataSource(dataSource);
    // setTranslationCache(translationCache);
  };

  const getColor = (status) => {
    if (status === 'critical') {
      return 'rgb(251, 133, 133)';
    } else if (status === 'medium') {
      return '#f7c66c';
    } else {
      return '#f9f9a3';
    }
  };

  const handleOk = () => {
    const payload = {
      ...feedbackForm,
      'Notification Id': feedbackForm.NotificationId,
      'Tag Description': feedbackForm.TagDescription
    };
    const accessToken = localStorage.get('accessToken');
    const deviceTypeObject = {
      method: 'POST',
      url: `${PREDICTIONS.UPDATE}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    return axios(deviceTypeObject)
      .then(() => {
        setOpenModal(false);
        props.refereshData('close');
      })
      .catch(() => {
        return 'error';
      });
  };

  const handleCancel = () => {
    setOpenModal(false);
    props.refereshData('close');
  };

  return (
    <div>
      {date ? (
        <div style={{ padding: '20px' }}>
          {dataSource.length > 0 ? (
            <Fragment>
              <div style={{ fontWeight: 'bold', color: 'white' }}>
                {moment.utc(date, 'YYYY-MM-DD HH:mm').local().format('YYYY-MM-DD HH:mm')}
              </div>

              <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                <div style={{ marginRight: '5px', color: 'white' }}>
                  - {props.language !== 'English' ? '低' : 'Low'}
                </div>
                <div style={{ width: '25px', marginRight: '5px', height: '20px', backgroundColor: '#f9f9a3' }}></div>
                <div style={{ marginRight: '5px', color: 'white' }}>
                  - {props.language !== 'English' ? '中' : 'Medium'}
                </div>
                <div style={{ width: '25px', marginRight: '5px', height: '20px', backgroundColor: '#f7c66c' }}></div>
                <div style={{ marginRight: '5px', color: 'white' }}>
                  - {props.language !== 'English' ? 'クリティカル' : 'Critical'}
                </div>
                <div style={{ width: '25px', marginRight: '5px', height: '20px', backgroundColor: 'rgb(251, 133, 133)' }}></div>
              </div>

              <StyledTable size="small"
                className="TableLightWidget"
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                
                scroll={{ y: 240 }}
                bordered
              />
            </Fragment>
          ) : Object.keys(props.feedbackForm).length > 0 ? (
            <AnomalyFeedbackTable
              notification={props.feedbackForm}
              openModel={true}
              refereshData={(refresh) => {
                props.refereshData(refresh);
              }}
            />
          ) : null}
        </div>
      ) : null}
      <Modal
        open={openModal}
        width={800}
        height={800}
        title={props.language !== 'English' ? '予測フィードバック' : 'Prediction Feedback'}
        okText="Submit"
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form {...formItemLayout}>
          <Form.Item label={props.language !== 'English' ? '時間' : 'TimeStamp'}>
            <Input
              readOnly
              value={moment.utc(feedbackForm.Timestamp, 'YYYY-MM-DD HH:mm').local().format('YYYY-MM-DD HH:mm')}
            />
          </Form.Item>
          {feedbackForm.NotificationId ? (
            <Form.Item label={props.language !== 'English' ? '通知ID' : 'Notification Id'}>
              <Input readOnly value={feedbackForm.NotificationId} />
            </Form.Item>
          ) : null}
          <Form.Item label={props.language !== 'English' ? 'タグ名' : 'Tag Name'}>
            <Input readOnly value={feedbackForm.TagName} />
          </Form.Item>
          {feedbackForm.NotificationId ? (
            <Form.Item label={props.language !== 'English' ? '通知' : 'Notification'}>
              <Input readOnly value={feedbackForm.TagDescription} />
            </Form.Item>
          ) : null}
          <Form.Item label={props.language !== 'English' ? 'アクション' : 'Action'}>
            <Radio.Group
              value={feedbackForm.Action}
              onChange={(e) => setFeedbackForm({ ...feedbackForm, Action: e.target.value })}
            >
              <Radio value="yes">{props.language !== 'English' ? 'はい' : 'Yes'}</Radio>
              <Radio value="no">{props.language !== 'English' ? 'いいえ' : 'No'}</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={props.language !== 'English' ? 'コメント' : 'Comment'}>
            <Input.TextArea
              value={feedbackForm.Comment}
              onChange={(e) => setFeedbackForm({ ...feedbackForm, Comment: e.target.value })}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(SummaryTable);